import React, { Fragment } from "react";

function AboutContentEn() {
  return (
    <Fragment>
      <section className="about_banner" dir="ltr">
        <div className="container">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6 d-flex align-items-center">
              <div className="col_selector text-right">
                <h2 className="poppinssemibold mb-2">About</h2>
                <p className="fz13 poppinsregular">We believe by bringing neighbors together, we can cultivate a kinder world where everyone has a neighborhood they can rely on.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="terms_condition_section about_page pb-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="col_selector">
                <h3 className="fz18 poppinssemibold mb-4">Introduction</h3>
                <p>Houmti is a social and e-commerce app that helps you stay connected with your neighbours. As an alternative to traditional forms of social media, Houmti allows you to build closer relationships with your neighbours and stay on top of the latest news and deals in your neighbourhood.</p>
                <p>It makes it easier to get information about services (both private and public) and businesses from sources you trust, your neighbours in the same Daira or surrounding Dairas.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
}

export default AboutContentEn;
